module.exports = __webpack_public_path__ + "img/cake-22.ccd08fec.svg";